export const getSumScoreSorted = countries => {
	return countries.sort((a, b) => {
		if (a.score === b.score) {
			return 0;
		}
		return a.score > b.score ? -1 : 1;
	});
};
